var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-library"},[_c('header-simple',{attrs:{"id":"demo-library-header","title":_vm.title}}),_vm._v(" "),_c('tabs',_vm._b({attrs:{"id":"demo-library-tabs"}},'tabs',_vm.tabsSettings,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }